import React, { useEffect } from 'react'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import highchartsWindbarb from 'highcharts/modules/windbarb'
import highchartsAccessibility from 'highcharts/modules/accessibility'
import { getOpciones } from '../pronostico/pronosticoMarinoUtils'
import PropTypes from 'prop-types'

// init the module
highchartsAccessibility(Highcharts)
highchartsWindbarb(Highcharts)

import { useState } from 'react'
import { Dropdown } from 'react-bootstrap'

import './PronosMarinoPuntoH.css'

export default function PronosMarinoPuntoH({
    serieDirViento,
    serieIntViento,
    serieIntRafaga,
    serieAltOla,
    serieDirOla,
    seriePeriodoOla,
    fechaInicio,
    horasPronostico,
    resolucionTemporalHoras,
    //serieVisibilidad,
    serieTempAire,
    seriePrecipitacion,
    seriePresion,
    serieTotalCieloCubierto,
}) {
    const [indexSelector, setIndexSelector] = useState(0)

    let [listaConfigGraficas, setListaConfigGraficas] = useState({
        listaTitulos: [],
        listaOpciones: [],
        listaIconos: [],
    })

    useEffect(() => {
        let maxViento = getMaxValorY(serieIntRafaga, [0, 5, 10, 15, 20, 40, 80])
        let maxAltOlas = getMaxValorY(
            serieAltOla,
            [0, 1, 2, 3, 4, 5, 10, 15, 20, 40]
        )
        let maxPeriodoOlas = getMaxValorY(
            seriePeriodoOla,
            [0, 5, 10, 15, 20, 40]
        )
        let maxTempAire = getMaxValorY(
            serieTempAire,
            [10, 20, 22, 24, 25, 30, 40, 50]
        )
        let minTempAire = getMinValorY(serieTempAire, [20, 18, 15, 10, 0])
        let maxPrecip = getMaxValorY(
            seriePrecipitacion,
            [3, 5, 10, 20, 30, 40, 50]
        )
        let maxPresAtmMar = getMaxValorY(
            seriePresion,
            [1000, 1010, 1020, 1030, 1040, 1050]
        )
        let minPresAtmMar = getMinValorY(seriePresion, [1020, 1010, 1000, 980])

        //let maxVisibilidad = getMaxValorY(serieVisibilidad, [5, 10, 20, 30, 40])

        const opcionesViento = getOpciones(
            310,
            Highcharts,
            fechaInicio,
            horasPronostico,
            resolucionTemporalHoras,
            resolucionTemporalHoras,
            serieIntViento,
            serieIntRafaga,
            serieDirViento,
            ['Int. Viento', 'Int. Ráfaga', 'Dir. Viento'],
            ['kt', 'kt', 'º'],
            ['area', 'area'],
            { max: maxViento, min: 0 }
        )
        const opcionesOlas = getOpciones(
            310,
            Highcharts,
            fechaInicio,
            horasPronostico,
            resolucionTemporalHoras,
            resolucionTemporalHoras,
            serieAltOla,
            undefined,
            serieDirOla,
            ['Altura de Ola', '', 'Dir. de Ola'],
            ['m', 's', 'º'],
            ['area', 'area'],
            { max: maxAltOlas, min: 0 }
        )

        const opcionesPeriodoOlas = getOpciones(
            310,
            Highcharts,
            fechaInicio,
            horasPronostico,
            resolucionTemporalHoras,
            resolucionTemporalHoras,
            seriePeriodoOla,
            undefined,
            serieDirOla,
            ['Período de Ola', '', 'Dir. de Ola'],
            ['s', '', 'º'],
            ['area', 'area'],
            { max: maxPeriodoOlas, min: 0 }
        )
        const opcionesTempAire = getOpciones(
            310,
            Highcharts,
            fechaInicio,
            horasPronostico,
            resolucionTemporalHoras,
            resolucionTemporalHoras,
            serieTempAire,
            undefined,
            undefined,
            ['Temperatura de superficie del mar'],
            ['°C', '', ''],
            ['area'],
            { max: maxTempAire, min: minTempAire }
        )

        const opcionesPrecip = getOpciones(
            310,
            Highcharts,
            fechaInicio,
            horasPronostico,
            resolucionTemporalHoras,
            resolucionTemporalHoras,
            seriePrecipitacion,
            undefined,
            undefined,
            ['Precipitación'],
            ['mm', '', ''],
            ['column'],
            { max: maxPrecip, min: 0 }
        )

        const opcionesPresAtm = getOpciones(
            310,
            Highcharts,
            fechaInicio,
            horasPronostico,
            resolucionTemporalHoras,
            resolucionTemporalHoras,
            seriePresion,
            undefined,
            undefined,
            ['Pres.Atm. a nivel del Mar'],
            ['hPa', '', ''],
            ['area'],
            { max: maxPresAtmMar, min: minPresAtmMar }
        )

        const opcionesTotCieloCubierto = getOpciones(
            310,
            Highcharts,
            fechaInicio,
            horasPronostico,
            resolucionTemporalHoras,
            resolucionTemporalHoras,
            serieTotalCieloCubierto,
            undefined,
            undefined,
            ['Cobertura total de nubes'],
            ['%', '', ''],
            ['column'],
            { max: 100, min: 0 }
        )
        const listaTitulos = [
            'Int.,Dir. de Viento y Ráfagas',
            'Altura y Dirección de Olas',
            'Período de Olas',
            'Precipitación',
            // 'Visibilidad Horizontal',
            'Temperatura de superficie del mar',
            'Presión Atmosférica',
            'Cobertura total de nubes',
        ]

        const listaTitulosCortos = [
            'Viento',
            'Olas',
            'Per.Olas',
            'Precip.',
            //'Visibilidad',
            'Temp.Sup.Mar',
            'PresAtm',
            'Cielo',
        ]

        const listaIconos = [
            'wind',
            'water',
            'clock',
            'cloud-showers-water',
            'binoculars',
            'temperature-half',
            'gauge',
            'cloud-sun',
        ]

        const listaOpciones = [
            opcionesViento,
            opcionesOlas,
            opcionesPeriodoOlas,
            opcionesPrecip,
            //opcionesVisibilidad,
            opcionesTempAire,
            opcionesPresAtm,
            opcionesTotCieloCubierto,
        ]
        setListaConfigGraficas({
            listaTitulos,
            listaOpciones,
            listaIconos,
            listaTitulosCortos,
        })
    }, [])
    let opcionesSelector = []
    let crearGrafica = (index, listaConfigGraficas) => {
        opcionesSelector.push(
            <Dropdown.Item
                key={index}
                onClick={() => {
                    setIndexSelector(index)
                }}
            >
                {listaConfigGraficas.listaTitulos[index]}
            </Dropdown.Item>

            /*            {
            label: listaConfigGraficas.listaTitulos[index],
            value: index,
        }*/
        )

        return (
            <HighchartsReact
                highcharts={Highcharts}
                key={index}
                options={listaConfigGraficas.listaOpciones[index]}
            />
        )
    }
    let componentes = []
    for (let i = 0; i < listaConfigGraficas.listaTitulos.length; i++) {
        componentes.push(crearGrafica(i, listaConfigGraficas))
    }
    return (
        <>
            <Dropdown className="full-width-dropdown w-100">
                <Dropdown.Toggle
                    variant="outline-secondary"
                    size="sm"
                    className="d-flex align-items-center justify-content-between w-100"
                >
                    <span>{opcionesSelector[indexSelector]}</span>
                </Dropdown.Toggle>

                <Dropdown.Menu className="w-100">
                    {opcionesSelector}
                </Dropdown.Menu>
            </Dropdown>

            {componentes[indexSelector]}
        </>
    )
}

function getMaxSerie(serie) {
    let max = undefined
    if (serie) {
        serie.forEach((itemSerie) => {
            if (max === undefined || max < itemSerie) max = itemSerie
        })
    }
    if (max !== undefined) return max
    return 0
}

function getMinSerie(serie) {
    let min = undefined
    if (serie) {
        serie.forEach((itemSerie) => {
            if (min === undefined || min > itemSerie) min = itemSerie
        })
    }
    if (min !== undefined) return min
    return 0
}

function getMaxValorY(serie, niveles) {
    let max = getMaxSerie(serie)
    return niveles.find((itemNiveles) => {
        return itemNiveles > max
    })
}

function getMinValorY(serie, niveles) {
    let min = getMinSerie(serie)
    return niveles.find((itemNiveles) => {
        return itemNiveles < min
    })
}

PronosMarinoPuntoH.propTypes = {
    serieDirViento: PropTypes.array,
    serieIntViento: PropTypes.array,
    serieIntRafaga: PropTypes.array,
    serieAltOla: PropTypes.array,
    serieDirOla: PropTypes.array,
    seriePeriodoOla: PropTypes.array,
    //serieVisibilidad: PropTypes.array,
    serieTempAire: PropTypes.array,
    seriePresion: PropTypes.array,
    seriePrecipitacion: PropTypes.array,
    serieTotalCieloCubierto: PropTypes.array,
    fechaInicio: PropTypes.object,
    horasPronostico: PropTypes.number,
    resolucionTemporalHoras: PropTypes.number,
}
